import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

function TabPaper({ children, className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div className={cn('border-border bg-card rounded-b-xl border p-5', className)} {...props}>
            {children}
        </div>
    );
}

export default TabPaper;
